<template>
  <div class="bg-white rounded-xl border overflow-hidden">
    <!-- Header -->
    <div class="flex items-center justify-between px-4 py-3 border-b border-neutral-100 bg-neutral-50">
      <h4 class="text-sm font-semibold text-neutral-800">{{ $t('Labels') }}</h4>
      <LabelsSidebar
        :labels="allLabels"
        @createdLabel="addLabel($event)"
        @updatedLabel="updateLabel($event)"
        @destroyedLabel="removeLabel($event)"
      ></LabelsSidebar>
    </div>

    <!-- Labels List -->
    <div class="p-2">
      <input type="hidden" name="changelog_entry[label_ids][]" value="" />

      <label
        v-for="label in allLabels"
        :key="label.id"
        :for="'changelog_entry_label_ids_' + label.id"
        class="flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer hover:bg-neutral-50 transition-colors group"
      >
        <!-- Custom Checkbox -->
        <div class="relative flex-shrink-0">
          <input
            type="checkbox"
            :value="label.id"
            :checked="label.checked"
            name="changelog_entry[label_ids][]"
            :id="'changelog_entry_label_ids_' + label.id"
            class="peer sr-only"
          />
          <div
            class="w-5 h-5 rounded-md border-2 border-neutral-300 peer-checked:border-transparent transition-all"
            :class="{ 'peer-checked:bg-current': true }"
            :style="{ '--tw-bg-opacity': 1, color: label.color }"
          ></div>
          <div
            class="absolute inset-0 flex items-center justify-center opacity-0 peer-checked:opacity-100 transition-opacity"
          >
            <svg class="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <!-- Label Color Dot & Name -->
        <div class="flex items-center gap-2 min-w-0">
          <span
            class="w-2.5 h-2.5 rounded-full flex-shrink-0"
            :style="{ backgroundColor: label.color }"
          ></span>
          <span class="text-sm text-neutral-700 truncate group-hover:text-neutral-900">
            {{ label.name }}
          </span>
        </div>
      </label>

      <!-- Empty State -->
      <div v-if="allLabels.length === 0" class="px-3 py-4 text-center">
        <p class="text-sm text-neutral-600">{{ $t('No labels yet') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import LabelsSidebar from "./index";

export default {
  props: ["labels"],
  data: function() {
    return {
      allLabels: this.labels
    };
  },

  components: {
    LabelsSidebar
  },

  methods: {
    addLabel(label) {
      this.allLabels.push(label);
    },

    removeLabel(label) {
      this.allLabels.splice(this.allLabels.indexOf(label), 1);
    },

    updateLabel(label) {
      // this.$emit("updatedLabel", label);
    }
  }
};
</script>

<style scoped lang="scss">
// Custom checkbox with label color
.peer:checked ~ div:first-of-type {
  background-color: var(--label-color, currentColor);
}
</style>
